export default function authHeader() {
  const obj = JSON.parse(localStorage.getItem("authUser"))

  if (obj && obj.access) {
    return "JWT " + obj.access
  } else {
    return {}
  }
}
